import { Pipe, PipeTransform } from '@angular/core';
import { formatMmaLabelForDisplay } from '../utils/time-period-display.util';

/**
 * Display-only: shows MMA time periods as Rolling Ave.
 * Do not use on values that are sent back to the API.
 */
@Pipe({ name: 'mmaDisplay' })
export class MmaDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatMmaLabelForDisplay(value);
  }
}
